<template>
    <ListenerArtistTracks v-if="isListenerMobile" />
    <ArtistTracks v-else />
</template>

<script>
import ArtistTracks from './ArtistTracks.vue'
import ListenerArtistTracks from './ListenerArtistTracks.vue'

export default {
    name: 'ArtistTracksEntry',
    components: {
        ArtistTracks,
        ListenerArtistTracks
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
